import React from 'react';
import DateTime, { Parser } from '@dealroadshow/uikit-date-time';
import { ITimezone } from '@framework/timezone/vo/Timezone';
import { IFileUploadEmailAlerts } from '../../../domain/vo/FileUploadEmailAlerts';
import { IStagingFileUploadEmailAlerts } from '../../../domain/vo/StagingFileUploadEmailAlerts';
import { IDigestEmailAlerts } from '../../../domain/vo/DigestEmailAlerts';
import { IAccessRequestEmailAlerts } from '../../../domain/vo/AccessRequestEmailAlerts';
import { IQuestionsEmailAlerts } from '../../../domain/vo/QuestionsEmailAlerts';

export const convertTime = (time: string | undefined, abbr: string | undefined) => (
  time && `${ new DateTime(time, { parsers: [new Parser({ format: 'H:mm:ss' })] }).format('ha') }${ abbr ? ` ${ abbr }` : '' }`
);

export const convertArrayTime = (timeArray: string[] | undefined, abbr: string | undefined) => timeArray?.map((time) => convertTime(time, abbr)).join(', ');

const getEmailAlerts = ({ alertSettings, isShort = false, timezone }: {
  alertSettings?: IFileUploadEmailAlerts |
    IStagingFileUploadEmailAlerts |
    IDigestEmailAlerts |
    IAccessRequestEmailAlerts |
    IQuestionsEmailAlerts,
  isShort?: boolean,
  timezone?: ITimezone,
}) => {
  const { daily, weekly } = alertSettings || {};

  return [
    {
      enabled: daily?.enabled,
      label: `${ isShort ? 'Dly' : 'Daily at' } ${
        Array.isArray(daily?.time) ?
          convertArrayTime(daily?.time, timezone?.abbr) :
          convertTime(daily?.time, timezone?.abbr)
      }`,
    },
    {
      enabled: weekly?.enabled,
      label: isShort ?
        `Wkly ${ convertTime(weekly?.time, timezone?.abbr) }` :
        `Weekly on ${ weekly?.day } at ${ convertTime(weekly?.time, timezone?.abbr) }`,
    },
  ];
};

const DigestEmailAlertsText = ({ alertSettings, isShort = false, timezone }: {
  alertSettings?: IDigestEmailAlerts,
  isShort?: boolean,
  timezone?: ITimezone,
}) => (
  <>{ getEmailAlerts({ alertSettings, isShort, timezone })
      .filter((item) => item.enabled)
      .map((item) => item.label)
      .join(', ') || 'None' }
  </>
);

const EmailAlertsText = ({ alertSettings, isShort = false, timezone }: {
  alertSettings?: IFileUploadEmailAlerts |
    IStagingFileUploadEmailAlerts |
    IAccessRequestEmailAlerts |
    IQuestionsEmailAlerts,
  isShort?: boolean,
  timezone?: ITimezone,
}) => {
  const { realtime } = alertSettings || {};

  return (
    <>
      { [
        {
          enabled: realtime?.enabled,
          label: isShort ? 'RT' : 'Real-time',
        },
        ...getEmailAlerts({ alertSettings, isShort, timezone }),
      ]
      .filter((item) => item.enabled)
      .map((item) => item.label)
      .join(', ') || 'None' }
    </>
  );
};

export { DigestEmailAlertsText, EmailAlertsText };
